export default __webpack_public_path__ + "static/home2-8f843e85bc684ddd9ad16fb55bc0f7c0.jpeg";